<script setup lang="ts">
const props = defineProps<{
	index: number
	text: string
	author: string
	stars: number | string
}>()

const i18nService = usei18nService()
const swiper = useSwiper()
</script>

<template>
	<article class="testimonial" :data-active="props.index === swiper.realIndex">
		<div class="testimonial__stars">
			<!-- <GlobalIcon v-for="i in Number(stars)" :key="i" name="star-icon-color" :height="20" /> -->
			<GlobalIcon v-for="i in Number(stars)" :key="i" name="star-icon-color" :height="props.index === swiper.realIndex ? 20 : 14" />
		</div>
		<p class="testimonial__text" v-html="i18nService.$tDynamic('modules.home_page_module.testimonials.data', props.text)"></p>
		<span class="testimonial__author"> {{ i18nService.$tDynamic('modules.home_page_module.testimonials.data', props.author) }}</span>
	</article>
</template>

<style lang="scss">
@import './Item';
</style>
